<div class="ap-kv">
    <p class="ap-section-label" *ngIf="section.label">{{ section.label }}</p>
    <dl class="ap-kv-list">
        <ng-container *ngFor="let item of section.items; trackBy: trackByIndex">
            <dt class="ap-kv-label">{{ item.label }}</dt>
            <dd class="ap-kv-value">{{ item.value }}</dd>
        </ng-container>
    </dl>
</div>
